export const title = {
  brandSetting: {
    verification: 'verification',
    country: 'country',
    currency: 'currency',
    language: 'language',
    domain: 'domain',

    captcha: 'captcha',
    player: 'player',

    sms: 'sms',
    smtp: 'smtp',
    email: 'email',
    preferences: 'preferences',
    telegram: 'telegram',
    whatsApp: 'whatsApp',

    affiliate: 'affiliate',
    gamification: 'gamification',
    analytics: 'analytics',
    liveChatSolution: 'liveChatSolution',
    customScript: 'customScript',
    agSolution: 'agSolution',
    crm: 'crm',
    retailSolution: 'retailSolution',
    authentication: 'authentication',
    artificialIntelligence: 'artificialIntelligence',
    services: 'services',

    deposit: 'deposit',
    withdrawal: 'withdrawal',
    other: 'other',
    bet: 'bet',

    blockedCountries: 'blockedCountries',
    ipWhitelist: 'ipWhitelist',

    operationalLimits: 'operationalLimits',
    largeTransactions: 'largeTransactions',
    playerLimits: 'playerLimits',
    responsibleGaming: 'responsibleGaming',

    failedPayments: 'failedPayments',
    methods: 'methods',
    settings: 'settings',

    fees: 'fees',
    limits: 'limits',

    playerVerification: 'playerVerification',
    verificationConf: 'verificationConf',
    unverifiedPlayersExclusions: 'unverifiedPlayersExclusions',
    documentType: 'documentType',
    eddVerification: 'eddVerification',
    pendingDocumentVerification: 'pendingDocumentVerification',

    layouts: 'layouts',
    walletsSettings: 'walletsSettings',
    sportStatusIcons: 'sportStatusIcons',
    verificationRules: 'verificationRules',

    providersAndGames: 'providersAndGames',
    jackpots: 'jackpots',

    financialConfigurations: 'financialConfigurations',
    paymentVisibility: 'paymentVisibility',
    currencyConfigs: 'currencyConfigs',
    currencySettings: 'currencySettings',
    inactivity: 'inactivity',
    kyc: 'kyc',
    mainDomains: 'mainDomains',
    sportDomains: 'sportDomains',
    general: 'general',
    wins: 'wins',
    countries: 'countries',
    nationality: 'nationality',
    betStatusCorrections: 'betStatusCorrections',
    mobileCodes: 'mobileCodes',
    balanceAdjustments: 'balanceAdjustments',
    bonusGrants: 'bonusGrants',
    magicLink: 'magicLink',
    exportCenter: 'exportCenter',

    bonuses: 'bonuses',
    referral: 'referral',
    activationRules: 'activationRules',
  },
  communication: {
    sent: 'sent',
    scheduled: 'scheduled',
    draft: 'draft',
  },
  translation: {
    mainContent: 'mainContent',
    errorMessages: 'errorMessages',
    reasonsContent: 'reasonsContent',
  },
  player: {
    accountDetails: 'accountDetails',
    limits: 'limits',
    payments: 'payments',
    bets: 'bets',
    adjustments: 'adjustments',
    bonuses: 'bonuses',
    wagers: 'wagers',
    monitoring: 'monitoring',
    auditLogs: 'auditLogs',
    tags: 'tags',
    comms: 'comms',
    notes: 'notes',
    kpis: 'kpis',
    attachments: 'attachments',
    history: 'history',
    details: 'details',
    preferences: 'preferences',
    segments: 'segments',
    referees: 'referees',
    sport: 'sport',
    casino: 'casino',
    deposits: 'deposits',
    withdrawals: 'withdrawals',
    responsibleGaming: 'responsibleGaming',
    logs: 'logs',
    cashbackBonus: 'cashbackBonus',
    referralBonus: 'referralBonus',
    massMessages: 'massMessages',
    inboxMessages: 'inboxMessages',
    actions: 'actions',
    sessions: 'sessions',
    userLogs: 'userLogs',
    playerLogs: 'playerLogs',
    previousAccounts: 'previousAccounts',
    similarAccounts: 'similarAccounts',
    legalAgreements: 'legalAgreements',
    blockedProviders: 'blockedProviders',
    blockedPayments: 'blockedPayments',
    nraLogs: 'nraLogs',
    selfieKycLogs: 'selfieKycLogs',
    accountUpdates: 'accountUpdates',
    systemNotifications: 'systemNotifications',
    overview: 'overview',
    vertical: 'vertical',
    horizontal: 'horizontal',
    gamification: 'gamification',
    spins: 'spins',
    transactions: 'transactions',
    pushNotifications: 'pushNotifications',
    bonusNotifications: 'bonusNotifications',
    taxSessions: 'taxSessions',
    gameSessions: 'gameSessions',
    gamStopLogs: 'gamStopLogs',
  },
  template: {
    systemTemplates: 'systemTemplates',
    customTemplates: 'customTemplates',
  },
  bonuses: {
    casino: 'casino',
    spins: 'spins',
    sport: 'sport',
    special: 'special',
  },
  bulkActions: {
    statusUpdates: 'statusUpdates',
    balanceAdjustments: 'balanceAdjustments',
    promoSpinsAdjustments: 'promoSpinsAdjustments',
    blockAccess: 'blockAccess',
    providers: 'providers',
    paymentMethods: 'paymentMethods',
    selfExclusions: 'selfExclusions',
  },
  cashBack: {
    accumulatedCashBack: 'accumulatedCashBack',
    transferredCashBack: 'transferredCashBack',
    failedCashBack: 'failedCashBack',
  },
  referral: {
    accumulated: 'accumulated',
    transferred: 'transferred',
    failed: 'failed',
  },
  auditLog: {
    userLogs: 'userLogs',
    playerLogs: 'playerLogs',
    userManagementLogs: 'userManagementLogs',
    episLogs: 'episLogs',
    gamStopLogs: 'gamStopLogs',
    nraLogs: 'nraLogs',
    selfieKycLogs: 'selfieKycLogs',
  },
  playerReports: {
    closedAccounts: 'closedAccounts',
    playersTotals: 'playersTotals',
    inactivePlayers: 'inactivePlayers',
    topPlayers: 'topPlayers',
    byGgr: 'byGgr',
    byDeposits: 'byDeposits',
    byWithdrawals: 'byWithdrawals',
  },
  financialReports: {
    balanceAdjustments: 'balanceAdjustments',
    wallets: 'wallets',
    firstDeposits: 'firstDeposits',
    byPlayer: 'byPlayer',
    byBrand: 'byBrand',
  },
  compliance: {
    largeTransactions: 'largeTransactions',
    negativeBalance: 'negativeBalance',
    liability: 'liability',
    playerLimits: 'playerLimits',
    blockedPlayers: 'blockedPlayers',

    byTransaction: 'byTransaction',
    byPlayer: 'byPlayer',
    byBrand: 'byBrand',

    selfExclusions: 'selfExclusions',
    amountLimits: 'amountLimits',
    timeLimits: 'timeLimits',
  },
  deviceSessions: {
    applicationSessions: 'applicationSessions',
    webSessions: 'webSessions',
  },
  bets: {
    casino: 'casino',
    sport: 'sport',
  },
  biReports: {
    betAggregations: 'betAggregations',
    financialAggregations: 'financialAggregations',
    byPlayer: 'byPlayer',
    byCurrency: 'byCurrency',
  },
  userManagement: {
    myGroups: 'myGroups',
    defaultGroups: 'defaultGroups',
  },
  cms: {
    settings: 'settings',

    games: 'games',
    groups: 'groups',
    gameTypes: 'gameTypes',

    general: 'general',
    jackpot: 'jackpot',
    lobbyHome: 'lobbyHome',

    navigation: 'navigation',
  },
  tools: {
    reasons: 'reasons',
    resources: 'resources',

    vertical: 'vertical',
    horizontal: 'horizontal',
    logs: 'logs',

    players: 'players',
    games: 'games',
  },
  devTools: {
    dbSynchronization: 'dbSynchronization',
    jobs: 'jobs',
    userConfig: 'userConfig',
  },
  campaigns: {
    campaigns: 'campaigns',
    crossPlatformCampaigns: 'crossPlatformCampaigns',

    received: 'received',
    failed: 'failed',
  },
  gamification: {
    transactions: 'transactions',
    machines: 'machines',
    prizes: 'prizes',
    players: 'players',
    spins: 'spins',
    exchanges: 'exchanges',
  },
  bonusReports: {
    byPlayer: 'byPlayer',
    byType: 'byType',
    byStatus: 'byStatus',
    byProvider: 'byProvider',
  },
  betStatusCorrections: {
    singleBets: 'singleBets',
    bulkBets: 'bulkBets',
  },
  machineConfigChangeLogs: {
    prizeAndProbabilitySection: 'prizeAndProbabilitySection',
    advancedProbability: 'advancedProbability',
  },
  groupLimitChangeLogs: {
    general: 'general',
    advanced: 'advanced',
  },
  campaignV2Bonuses: {
    freeBet: 'freeBet',
    spin: 'spin',
    combined: 'combined',
    special: 'special',
    units: 'units',
  },
  similarAccounts: {
    byBrowserId: 'byBrowserId',
    byIp: 'byIp',
  },
  imageSourcePicker: {
    uploadFile: 'uploadFile',
    mediaLibrary: 'mediaLibrary',
  },
  system: {
    conversion: 'conversion',
    settings: 'settings',
    superiorList: 'superiorList',
  },
  taxation: {
    byPlayer: 'byPlayer',
    byCategory: 'byCategory',
  },
} as const;
